import Message from "../../message";
import {useMainStore} from "@/store";
import EventBus from "@/services/eventBus";
import router from "@/router";

export default class ChatMessageSent extends Message
{
    handle()
    {
        const store = useMainStore();
        const isOwnMessage = this.message.message.user_id === store.id;
        const isSystem = this.message.message.type === 'system';

        const isViewingChat = router.currentRoute.value.name === 'guild'
            && router.currentRoute.value.params.tab === 'chat';

        if (isOwnMessage || isSystem || isViewingChat) {
            this.message.message.read = true;
        }

        store.ADD_GUILD_CHAT_MESSAGE(this.message.message);

        if (!isOwnMessage && !isSystem && !isViewingChat) {
            store.UPDATE_UNREAD_MESSAGES(1);
        }

        EventBus.emit('message-added', this.message.message.id);
    }
}
